// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3oguTXhjb9eXBFTWsi3WcR"};